<template>
  <ims-modal
    class="ims-popmenu"
    headerClasses="hidden"
    :show="$store.state.interact.popmenu.show"
    type="bottom"
    @close="$store.dispatch('interact/popmenu/hide')"
  >
    <h2>{{ $store.state.interact.popmenu.title }}</h2>
    <div
      class="description"
      v-if="$store.state.interact.popmenu.description"
    >
      {{ $store.state.interact.popmenu.description }}
    </div>
    <div class="buttons">
      <ims-button
        @click="buttonSelected(button)"
        size="lg"
        class="btn-block btn-dark"
        v-for="(button, index) in $store.state.interact.popmenu.buttons"
        :key="index"
      >{{ button.title }}</ims-button>
      <ims-button
        size="lg"
        color="red"
        class="btn-block bg-red text-white"
        @click="cancel"
      >{{ cancelButton }}</ims-button>
    </div>
  </ims-modal>
</template>

<script>
export default {
  methods: {
    buttonSelected(btn) {
      if (btn.click) {
        btn.click();
      }
      this.$store.dispatch('interact/popmenu/hide');
    },
    cancel() {
      if (this.$store.state.interact.popmenu.onCancel) {
        this.$store.state.interact.popmenu.onCancel();
      }
      this.$store.dispatch('interact/popmenu/hide');
    }
  },
  computed: {
    cancelButton() {
      return this.$store.state.interact.popmenu.cancelButton || 'Cancel';
    }
  }
};
</script>

<style lang="scss">
.ims-popmenu {
  z-index: 1042 !important;
  .ims-modal-window {
    min-height: 100px;
    .modal-body {
      padding: 10px;
      background-color: #fff;
    }
  }
  h2 {
    margin: 0px 10px 10px;
    text-align: center;
    font-size: 1.2rem;
    font-weight: 500;
  }
  .ims-button {
    background-color: rgba(0, 0, 0, 0.1);
    color: #000;
    border: none;
    font-size: 1rem;
    line-height: 120%;
    min-height: 40px;
  }
  .description {
    font-size: 0.9rem;
    line-height: 115%;
    opacity: 0.7;
    padding: 0 10px 10px 10px;
    text-align: center;
  }
}
</style>
